module.exports = __webpack_public_path__ + "static/img/blog6.23f6c23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog6.jpg
// module id = fznq
// module chunks = 0